import Header from '@/components/Header';
import Footer from '@/components/Footer';
import ConnectionIssue from '@/components/ConnectionIssue';
import MobileBottomNav from '@/components/MobileBottomNav';

export default function ConnectionIssuePage() {
    return (
        <>
            <Header />
            <ConnectionIssue />
            <Footer hasMobileNav />
            <MobileBottomNav />
        </>
    );
}